import { createLogger } from "@/domain/logging";

// Scoped logger for QR generation
export const log = createLogger("QRGEN");
